import { render, staticRenderFns } from "./editStatic.vue?vue&type=template&id=02a5ecca"
import script from "./editStatic.vue?vue&type=script&lang=js"
export * from "./editStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports